import { getAppsGatewayUrl } from '../../../../../../../constants/env';
import { WORKFLOW_IDS } from './constants';
import type { FetchInvokeRequest, FetchSelectInput } from './types';

interface FetchSelectParams {
  jwt: string;
  sessionId: string;
  retailerMoniker: string;
  selection: FetchSelectInput;
}

export async function fetchSelect(params: FetchSelectParams): Promise<boolean> {
  const { jwt, sessionId, retailerMoniker, selection } = params;

  const invokeRequest: FetchInvokeRequest = {
    workflowId: WORKFLOW_IDS.FETCH_SELECT,
    context: { sessionId, retailerMoniker },
    body: selection,
  };

  try {
    const gatewayUrl = getAppsGatewayUrl();
    const res = await fetch(`${gatewayUrl}/invoke`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify(invokeRequest),
    });
    return res.ok;
  } catch (err) {
    console.error('Failed to submit Fetch plan selection:', err);
    return false;
  }
}
